import React from "react"
import { useState } from "react"
import { Wrapper } from "src/components/page-directory/Wrapper"
import styled from "styled-components"
import { InputTitle } from "../Title/InputTitle"
import { MiddleTitle } from "../Title/MiddleTitle"
import { Checkbox } from "src/components/Checkbox"
import { Radios } from "src/components/Radios"
import { BorderedButton } from "src/components/Button"
import { color, font } from "@smoothincorg/smooth-ui"
import { PropertyNewForm } from "../../hooks/usePropertyNewForm/usePropertyNewForm"
import { Tag } from "../Tag/Tag"
import { InputField } from "src/components/InputField"
import { SMOOTH_LINE_API_URL } from "src/lib/constants"

type Props = PropertyNewForm & {
  className?: string
}

const Component: React.VFC<Props> = (props) => {
  const [station, setStation] = useState("")
  const [special, setSpecial] = useState("")
  const [walks, setWalks] = useState("")
  const [image, setImage] = useState("")
  const [runNinja, setRunNinja] = useState(false)

  const displayNinja = props.formState.userId && props.formState.url

  return (
    <div className={props.className}>
      <Wrapper>
        <div className={`${props.className}-form`}>
          <section className={`${props.className}-section`}>
            <InputTitle>ユーザーID</InputTitle>
            <InputField
              id="favorited_property.user_id"
              name="favorited_property.user_id"
              value={props.formState?.userId}
              onChange={props.handleUserIdChange}
              placeholder="999"
              label=""
            />
          </section>
        </div>
        <div className={`${props.className}-scraper-form`}>
          <MiddleTitle>URLから物件データを作成</MiddleTitle>
          <section className={`${props.className}-section`}>
            <InputTitle>URL（入力してEnterで検索！）</InputTitle>
            <InputField
              id="url"
              name="url"
              value={props.formState.url}
              onChange={props.handleUrlChange}
              placeholder="https://titanicrising.jp"
              label=""
              onKeyPress={(e) => {
                if (e.key == "Enter") {
                  e.preventDefault()
                  props.handleUrlSubmit(props.formState.userId).then(() => {
                    if (displayNinja && runNinja) {
                      props.handleRunNinja(props.formState.url, props.formState.userId)
                    }
                  })
                }
              }}
            />
          </section>
          <section
            className={`${props.className}-section`}
            style={{ display: displayNinja ? "block" : "none" }}
          >
            <InputTitle>🥷</InputTitle>
            <Checkbox
              text="このURLで忍者を走らせる"
              checked={runNinja}
              onChange={() => setRunNinja((val) => !val)}
            />
          </section>
        </div>
        <form
          className={`${props.className}-image-form ${!props.formState.property?.id && "inactive"}`}
        >
          <MiddleTitle>画像データ</MiddleTitle>
          <InputTitle>物件の画像URL</InputTitle>
          <ul className={`${props.className}-image-list`}>
            {props.formState.property_images?.map((image) => (
              <li className={`${props.className}-image-list__item`} key={image.id}>
                <img src={image.full_path} alt={image.full_path} />
              </li>
            ))}
          </ul>
        </form>
        <form className={`${props.className}-form`}>
          <MiddleTitle>
            {props.formState.property?.id
              ? `${props.formState.property.building_name}（ID:${props.formState.property.id}）の編集`
              : "物件データの新規作成"}
          </MiddleTitle>
          <section className={`${props.className}-section`}>
            <InputTitle>物件名</InputTitle>
            <InputField
              id="building_name"
              name="building_name"
              value={props.formState.property?.building_name}
              onChange={props.handleChange}
              placeholder="にむらハウス"
              label=""
            />
          </section>
          <section className={`${props.className}-section`}>
            <InputTitle>家賃</InputTitle>
            <InputField
              id="rent_fee"
              name="rent_fee"
              type="number"
              value={props.formState.property?.rent_fee}
              onChange={props.handleChange}
              placeholder="60000"
              step={1000}
              label=""
            />
          </section>
          <section className={`${props.className}-section`}>
            <InputTitle>管理費・共益費</InputTitle>
            <InputField
              id="management_fee"
              name="management_fee"
              type="number"
              value={props.formState.property?.management_fee}
              onChange={props.handleChange}
              placeholder="3000"
              step={1000}
              label=""
            />
          </section>
          <section className={`${props.className}-section`}>
            <InputTitle>敷金</InputTitle>
            <InputField
              id="deposit"
              label=""
              name="deposit"
              type="number"
              value={props.formState.property?.deposit}
              onChange={props.handleChange}
              placeholder="3000"
              step={1000}
            />
          </section>
          <section className={`${props.className}-section`}>
            <InputTitle>礼金</InputTitle>
            <InputField
              id="gratuity_fee"
              name="gratuity_fee"
              type="number"
              value={props.formState.property?.gratuity_fee}
              onChange={props.handleChange}
              placeholder="3000"
              step={1000}
              label=""
            />
          </section>
          <section className={`${props.className}-section`}>
            <InputTitle>仲介手数料</InputTitle>
            <InputField
              id="brokerage_fee"
              name="brokerage_fee"
              type="number"
              value={props.formState.property?.brokerage_fee}
              onChange={props.handleChange}
              placeholder="3000"
              step={1000}
              label=""
            />
          </section>
          <section className={`${props.className}-section`}>
            <InputTitle>その他初期費用</InputTitle>
            <InputField
              id="other_initial_cost"
              name="other_initial_cost"
              value={props.formState.property?.other_initial_cost}
              onChange={props.handleChange}
              placeholder="二村設置代 / 5万円"
              label=""
            />
          </section>
          <section className={`${props.className}-section`}>
            <InputTitle>住所</InputTitle>
            <InputField
              id="address"
              name="address"
              value={props.formState.property?.address}
              onChange={props.handleChange}
              placeholder="二村県二村市二村2-6-26"
              label=""
            />
          </section>
          <span className={`${props.className}-divider`} />
          <section className={`${props.className}-section`}>
            <InputTitle>広さ</InputTitle>
            <InputField
              id="breadth_floor"
              name="breadth_floor"
              value={props.formState.property?.breadth_floor}
              onChange={props.handleChange}
              placeholder="260"
              label=""
            />
          </section>
          <section className={`${props.className}-section`}>
            <InputTitle>間取り</InputTitle>
            <InputField
              id="madori"
              name="madori"
              value={props.formState.property?.madori}
              onChange={props.handleChange}
              placeholder="5000LDK"
              label=""
            />
          </section>
          <section className={`${props.className}-section`}>
            <InputTitle>築年数</InputTitle>
            <InputField
              id="building_age"
              name="building_age"
              value={props.formState.property?.building_age}
              onChange={props.handleChange}
              placeholder="築3年/2019年1月"
              label=""
            />
          </section>
          <section className={`${props.className}-section`}>
            <InputTitle>建物種別</InputTitle>
            <InputField
              id="build_type"
              name="build_type"
              value={props.formState.property?.build_type}
              onChange={props.handleChange}
              placeholder="マンション"
              label=""
            />
          </section>
          <section className={`${props.className}-section`}>
            <InputTitle>建物構造</InputTitle>
            <InputField
              id="build_const"
              name="build_const"
              value={props.formState.property?.build_const}
              onChange={props.handleChange}
              placeholder="鉄筋コン"
              label=""
            />
          </section>
          <section className={`${props.className}-section`}>
            <InputTitle>紹介可能ステータス</InputTitle>
            <Radios
              onChange={(e) => props.handleChange(e)}
              id={`introduction_status`}
              value={props.formState.property?.introduction_status ?? "unknown"}
              options={[
                {
                  name: "可能",
                  value: "can",
                },
                {
                  name: "不可能",
                  value: "cant",
                },
                {
                  name: "不明",
                  value: "unknown",
                },
              ]}
            />
          </section>
          <section className={`${props.className}-section`}>
            <InputTitle>駅（エンターで追加）</InputTitle>
            <InputField
              id="stations"
              name="stations"
              type="text"
              placeholder="二村駅"
              value={station}
              onChange={(e) => {
                e.target instanceof HTMLInputElement && setStation(e.target.value)
              }}
              label=""
              onKeyPress={(e) => {
                if (e.key == "Enter") {
                  e.preventDefault()
                  props.handleMultiChange("stations", station)
                }
              }}
            />
          </section>
          <section className={`${props.className}-section tag-wrapper`}>
            {props.formState.property?.stations?.map((station: string) => (
              <Tag
                key={station}
                onClick={() => props.handleMultiChange("stations", station, "remove")}
              >
                {station}
              </Tag>
            ))}
          </section>
          <section className={`${props.className}-section`}>
            <InputTitle>徒歩（エンターで追加）</InputTitle>
            <InputField
              id="walks"
              name="walks"
              type="text"
              placeholder="26分"
              value={walks}
              onChange={(e) => {
                e.target instanceof HTMLInputElement && setWalks(e.target.value)
              }}
              label=""
              onKeyPress={(e) => {
                if (e.key == "Enter") {
                  e.preventDefault()
                  props.handleMultiChange("walks", walks)
                }
              }}
            />
          </section>
          <section className={`${props.className}-section tag-wrapper`}>
            {props.formState.property?.walks?.map((walk: string) => (
              <Tag key={walk} onClick={() => props.handleMultiChange("walks", walk, "remove")}>
                {walk}
              </Tag>
            ))}
          </section>
          <section className={`${props.className}-section`}>
            <InputTitle>こだわり条件（エンターで追加）</InputTitle>
            <InputField
              id="specials"
              name="specials"
              type="text"
              placeholder="二村付き物件"
              value={special}
              onChange={(e) => {
                e.target instanceof HTMLInputElement && setSpecial(e.target.value)
              }}
              label=""
              onKeyPress={(e) => {
                if (e.key == "Enter") {
                  e.preventDefault()
                  props.handleMultiChange("specials", special)
                }
              }}
            />
          </section>
          <section className={`${props.className}-section tag-wrapper`}>
            {props.formState.property?.specials?.map((special: string) => (
              <Tag
                key={special}
                onClick={() => props.handleMultiChange("specials", special, "remove")}
              >
                {special}
              </Tag>
            ))}
          </section>
        </form>
        <div className={`${props.className}-button`}>
          <BorderedButton onClick={() => props.handlePropertySubmit(props.formState.userId)}>
            {props.formState.property?.id ? `変更する` : "保存する"}
          </BorderedButton>
        </div>
      </Wrapper>
    </div>
  )
}

const StyledComponent = styled(Component)`
  padding: 30px 0;

  h2 {
    margin-bottom: 30px;
    width: 100%;
  }

  &-scraper-form {
    padding: 30px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    border-bottom: 2px solid ${color.mediumLightGray};

    > section {
      width: 70%;
    }

    > section:last-child {
      width: 28%;
    }
  }

  &-section {
    width: 49%;
    margin-bottom: 16px;

    &.tag-wrapper {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      max-height: 600px;
      overflow: scroll;
    }

    > .radios {
      width: 100%;
    }

    > .checkbox {
      height: 48px;
    }
  }

  .input-title {
    display: inline-block;
    margin-bottom: 8px;
  }

  &-image-form {
    padding: 30px 0;
    border-bottom: 2px solid ${color.mediumLightGray};

    &.inactive {
      position: relative;
      pointer-events: none;

      * {
        pointer-events: none;
      }

      &::before {
        content: '';
        position: absolute;
        z-index: 2;
        background-color: rgba(255, 255, 255, 0.8);
        top: -10px;
        left: 0;
        right: 0;
        bottom: -10px;
      }

      &::after {
        content: '先に物件の情報を作成してください！';
        font-weight: bold;
        position: absolute;
        z-index: 3;
        ${font(18)};
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }

  &-form {
    padding: 30px 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  &-image-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    width: 100%;

    &__item {
      width: 12.5%;
      overflow: hidden;
      height: 140px;
      position: relative;
      border: 6px solid #ffffff;
      border-radius: 14px;
      margin-bottom: 8px;

      > img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: block;
        height: 100%;
        width: auto;
      }
    }
  }

  &-divider {
    height: 2px;
    background-color: ${color.mediumLightGray};
    width: 100%;
    margin: 30px 0;
  }

  &-button {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`

export const PropertyNew = StyledComponent
